"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { DEFAULT_MODAL_STATE } from "./useModalStore.js";
import { AccountPreviousStep, LoginPreviousStep, ModalStep, SignUpPreviousStep } from "../../utils/steps.js";
const getActions = (set, get) => ({
  resetState: () => set(DEFAULT_MODAL_STATE),
  setOnModalStepChange: (onModalStepChange) => set({ onModalStepChange }),
  setStep: (step) => {
    const onModalStepChange = get().onModalStepChange;
    const previousStep = get().step;
    set({ step });
    onModalStepChange == null ? void 0 : onModalStepChange({ previousStep, currentStep: step, canGoBack: get().hasPreviousStep() });
  },
  decrementStep: () => {
    var _a;
    const currentStep = get().step;
    const onRampStep = get().onRampStep;
    if ([ModalStep.ADD_FUNDS_BUY, ModalStep.ADD_FUNDS_WITHDRAW].includes(currentStep) && onRampStep > 0) {
      set({ onRampStep: onRampStep - 1 });
      return;
    }
    const onModalStepChange = get().onModalStepChange;
    const isLogin = get().flow === "login";
    const isAccount = get().flow === "account";
    const webAuthURLForCreate = get().webAuthURLForCreate;
    const iFrameUrl = get().iFrameUrl;
    const refs = get().refs;
    let prevStep = (isAccount ? AccountPreviousStep : isLogin ? LoginPreviousStep : SignUpPreviousStep)[currentStep];
    if (currentStep === ModalStep.PASSWORD_CREATION && iFrameUrl && !webAuthURLForCreate) {
      prevStep = ModalStep.AUTH_MAIN;
    }
    if (currentStep === ModalStep.EX_WALLET_SELECTED) {
      set({ selectedExternalWalletId: void 0, isExternalWalletConnecting: false, externalWalletError: void 0 });
    }
    if (prevStep) {
      set({ step: prevStep, stepDirection: -1 });
      onModalStepChange == null ? void 0 : onModalStepChange({ previousStep: currentStep, currentStep: prevStep, canGoBack: get().hasPreviousStep() });
    }
    (_a = refs.popupWindow.current) == null ? void 0 : _a.window.close();
    refs.popupWindow.current = void 0;
  },
  hasPreviousStep: () => {
    const isLogin = get().flow === "login";
    const isAccount = get().flow === "account";
    const currentStep = get().step;
    const onRampStep = get().onRampStep;
    if ([ModalStep.ADD_FUNDS_BUY, ModalStep.ADD_FUNDS_WITHDRAW].includes(currentStep) && onRampStep > 0) {
      return true;
    }
    return !!(isAccount ? AccountPreviousStep[currentStep] : isLogin ? LoginPreviousStep[currentStep] : SignUpPreviousStep[currentStep]);
  },
  setFlow: (flow) => set({ flow }),
  isLogin: () => get().flow === "login",
  isAccount: () => get().flow === "account",
  setWebAuthURLForLogin: (url) => set({ webAuthURLForLogin: url }),
  setWebAuthURLForCreate: (url) => set({ webAuthURLForCreate: url }),
  setPasswordUrlForLogin: (url) => set({ passwordUrlForLogin: url }),
  setSupportedAuthMethods: (supportedAuthMethods) => set({ supportedAuthMethods }),
  setOnRampPurchase: (onRampPurchase) => set((state) => ({ onRampPurchase: __spreadValues(__spreadValues({}, state.onRampPurchase || {}), onRampPurchase) })),
  setOnRampConfig: (onRampConfig) => set({ onRampConfig }),
  setOnRampStep: (onRampStep) => set({ onRampStep }),
  setIsFullyLoggedIn: (isFullyLoggedIn) => set({ isFullyLoggedIn }),
  setAccountAddFundTab: (accountAddFundTab) => set({ accountAddFundTab }),
  setSelectedExternalWalletId: (selectedExternalWalletId) => set({ selectedExternalWalletId }),
  setIsExternalWalletConnecting: (isExternalWalletConnecting) => set({ isExternalWalletConnecting }),
  setExternalWalletError: (externalWalletError) => set({ externalWalletError }),
  setIsUsingMobileConnector: (isUsingMobileConnector) => set({ isUsingMobileConnector }),
  setStepDirection: (stepDirection) => set({ stepDirection }),
  setFarcasterConnectUri: (farcasterConnectUri) => set({ farcasterConnectUri }),
  setBiometricLocationHints: (biometricLocationHints) => set({ biometricLocationHints }),
  setIFrameUrl: (iFrameUrl) => set({ iFrameUrl }),
  setIsIFrameReady: (isIFrameReady) => set({ isIFrameReady }),
  setAuthStepRoute: (authStepRoute) => set({ authStepRoute }),
  setIsPasskeySupported: (isPasskeySupported) => set({ isPasskeySupported })
});
export {
  getActions
};
